import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute, Outlet } from '@tanstack/react-router';

import { AuthenticatedUserProvider } from '@/components/providers/AuthenticatedUserProvider';
import { preLoadUserAndSession, userQueryOptions } from '@/lib/queries/auth';

export const Route = createFileRoute('/authorize')({
  component: OauthLayout,
  loader: preLoadUserAndSession,
});

function OauthLayout() {
  const { user, session } = Route.useLoaderData();
  useSuspenseQuery(userQueryOptions);

  return (
    <AuthenticatedUserProvider user={user} session={session}>
      <Outlet />
    </AuthenticatedUserProvider>
  );
}
